import { Injectable } from '@angular/core';
import { PreloadingStrategy, Route } from '@angular/router';
import { Observable, Subject, of } from 'rxjs';
import { filter, mergeMap, take } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class ViewportPreloadingStrategy implements PreloadingStrategy {
  private preloadOnDemand$ = new Subject<string>();

  preload(route: Route, load: () => Observable<unknown>): Observable<unknown> {
    if (!route.path) return of(null);

    const routeData = route.data as
      | {
          preload?: boolean;
          [key: string]: unknown;
        }
      | undefined;

    if (routeData?.preload) {
      return load();
    }

    return this.preloadOnDemand$.pipe(
      filter((path: string) => path === route.path),
      take(1),
      mergeMap(() => load())
    );
  }

  triggerPreload(path: string): void {
    const cleanPath = path.startsWith('/') ? path.substring(1) : path;
    this.preloadOnDemand$.next(cleanPath);
  }
}
